import { isPbTimestamp } from "./isPbTimestamp";
export var isTimeRange = function(timeRange) {
    return isPbTimestamp(timeRange === null || timeRange === void 0 ? void 0 : timeRange.from) && isPbTimestamp(timeRange === null || timeRange === void 0 ? void 0 : timeRange.to);
};
